import { isUserASuperAdmin } from 'utils/auth/authUtils';
import { User, UserEmployeeRole, UserType } from '../../models/Users';

export function convertUserToAppUser(user: User) {
  const accessToken = localStorage.getItem('access_token');
  const { agency, type: userType, uid: userUid, employeeRole } = user;
  const agencyUid = agency?.uid;
  const isAgent = userType === UserType.Agent;
  const isEmployee = userType === UserType.Employee;
  const isEmployeeAssociate =
    isEmployee && employeeRole === UserEmployeeRole.ASSOCIATE;
  const isEmployeeBookingAgent =
    isEmployee && employeeRole === UserEmployeeRole.BOOKING_AGENT;
  const isEmployeeManager =
    isEmployee && employeeRole === UserEmployeeRole.MANAGER;
  const isEmployeePropertySalesManager =
    isEmployee && employeeRole === UserEmployeeRole.PROPERTY_SALES_MANAGER;
  const isOwner = userType === UserType.Owner;
  const isServiceProvider = userType === UserType.ServiceProviderUser;
  const isSuperAdmin = isUserASuperAdmin(accessToken || '');

  return {
    agency,
    agencyUid,
    isAgent,
    employeeRole,
    isSuperAdmin,
    isEmployee,
    isEmployeeAssociate,
    isEmployeeBookingAgent,
    isEmployeeManager,
    isEmployeePropertySalesManager,
    isOwner,
    isServiceProvider,
    user,
    userType,
    userUid,
  };
}

type UserForBestProfile = {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  businessName?: string | null;
};

export const getBestProfile = (user?: UserForBestProfile): string => {
  if (user?.firstName && user?.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }

  if (user?.firstName) {
    return user.firstName;
  }

  if (user?.businessName) {
    return user.businessName;
  }

  if (user?.email) {
    if (user.email.includes('@')) {
      return user.email.substring(0, user.email.indexOf('@'));
    }
    return user.email;
  }

  return '';
};
